import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  MenuItem,
} from "@material-ui/core";
import { roles } from "../../Mappings";
import ButtonDelete from "../ButtonDelete";
import { ParcelDataContext } from "../../Contexts/ParcelDataContext";

const DeleteParcel = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { createParcelModel, comments } = useContext(ParcelDataContext);
  const parcelDataModel = createParcelModel({ week });

  const displayColumns = ["reason", comments];

  const [formData, setFormData] = useState({
    values: displayColumns.reduce((acc, cur) => ({ ...acc, [cur]: "" }), {}),
    valid: {},
  });

  const reasons = ["Duplicate DPC", "Other"];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      values: { ...formData.values, [name]: value },
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      valid: {
        ...Object.keys(formData.values).reduce(
          (acc, cur) => ({
            ...acc,
            [cur]: parcelDataModel[cur].validate(formData.values),
          }),
          {}
        ),
      },
    });
  }, [formData.values]);

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Delete DPC Item</DialogTitle>
      <DialogContent>
        <Grid container justify="flex-start" alignItems="stretch" spacing={1}>
          {displayColumns.map((col) => (
            <React.Fragment key={col}>
              <Grid item xs={3}>
                {parcelDataModel[col].displayName}:
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={formData.values[col]}
                  onChange={(event) => handleChange(event)}
                  error={!formData.valid[col]}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...parcelDataModel[col].textFieldProps}
                  {...(col === "reason" && {
                    children: reasons.map((e) => (
                      <MenuItem key={e} value={e}>
                        {e}
                      </MenuItem>
                    )),
                  })}
                />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDelete
          disabled={Object.values(formData.valid).includes(false)}
          variant="contained"
          color="primary"
          controller="parcels"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={{ ...itemData, ...formData.values }}
          callback={props.onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteParcel;

DeleteParcel.propTypes = {
  truckId: PropTypes.number.isRequired,
  itemData: PropTypes.object.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
};
